import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = ["textContent"]

import { computed, onMounted, ref, Ref } from 'vue';
import Chip from 'primevue/chip';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import ArchiveSwitch from '@/components/ArchiveSwitch';
import AddPersonModal from '@/components/AddPersonModal/AddPersonModal.vue';
import { useArchiveStore, useBillingAdminStore } from '@/store';
import { BillingAdminModal, BillingAdminTable } from '@/types';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum/permissions';


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingAdminTable',
  setup(__props) {

const billingAdminStore = useBillingAdminStore();
const archiveStore = useArchiveStore();
const billingAdmins: Ref<BillingAdminTable[]> = ref([]);
const billingAdminCount: Ref<number> = computed(() => (billingAdmins.value ? billingAdmins.value.length : 0));
const billingAdminModalOpen: Ref<boolean> = ref(false);
const archivedVisible = ref(false);
const billingAdminItems: Ref<BillingAdminModal[]> = ref([]);

onMounted((): void => {
  if (can([PERMISSIONS.ORGANIZATION_BILLING_ADMIN_INDEX])) getBillingAdmins(false);
});

const getBillingAdmins: (showArchived: boolean) => Promise<void> = async (showArchived: boolean) => {
  const filterArchived = showArchived ? '?archived=1' : '';
  await billingAdminStore
    .getBillingAdminsForTable(filterArchived)
    .then((result) => (billingAdmins.value = result))
    .catch((e) => {
      billingAdmins.value = [];
      throw e;
    });
};

const createMenuModel = (item: BillingAdminTable) => {
  const menuItems = [
    {
      label: 'Remove Billing Admin',
      visible: can([PERMISSIONS.ORGANIZATION_DETACH_BILLING_ADMINS]),
      command: () => {
        detachBillingAdmin([item.id], item.name);
      },
    },
  ];
  if (item.archived) {
    menuItems.push({
      label: 'Unarchive',
      visible: can([PERMISSIONS.PEOPLE_ARCHIVE]),
      command: async () => {
        await archiveStore.unarchive(item.id);
        archiveStore.doToast(`${item.name} has been restored`, 'Unarchived');
      },
    });
  }
  return menuItems;
};

const attachBillingAdmins: (ids: number[]) => Promise<void> = async (ids) => {
  await billingAdminStore.attachBillingAdmins(ids);
  getBillingAdmins(false);
  billingAdminStore.doToast('Billing Admin(s) has been added', 'Added');
};

const detachBillingAdmin: (ids: number[], billingAdminName: string) => Promise<void> = async (
  ids,
  billingAdminName,
) => {
  await billingAdminStore.detachBillingAdmins(ids);
  getBillingAdmins(false);
  billingAdminStore.doToast(`${billingAdminName} has been removed from organization`, 'Removed');
};

const openAddBillingAdminModal = async () => {
  billingAdminModalOpen.value = true;
  billingAdminItems.value = await billingAdminStore.getBillingAdminsAvailableToAdd();
};

const onCancelAdd = () => (billingAdminModalOpen.value = false);

const onSaveAdd = (billingAdmins: BillingAdminModal[]) => {
  let billingAdminIds = billingAdmins.map((billingAdmins) => {
    return billingAdmins.value;
  });
  attachBillingAdmins(billingAdminIds);
  billingAdminModalOpen.value = false;
};
const showArchived = () => {
  archivedVisible.value = true;
  billingAdminStore.showArchived = true;
  getBillingAdmins(true);
};
const hideArchived = () => {
  archivedVisible.value = false;
  billingAdminStore.showArchived = false;
  getBillingAdmins(false);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Billing Admins", -1)),
      _createVNode(_unref(Chip), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(billingAdminCount.value), 1)
        ]),
        _: 1
      }),
      (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_SCHOOL_SHOW_ARCHIVED]))
        ? (_openBlock(), _createBlock(_unref(ArchiveSwitch), {
            key: 0,
            onEnable: showArchived,
            onDisable: hideArchived
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_ATTACH_BILLING_ADMINS]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "text",
              size: "small",
              text: "Add Billing Admin",
              "icon-left": "add",
              onClick: openAddBillingAdminModal
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(DataTable), {
        value: billingAdmins.value,
        "global-filter-fields": ['name'],
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: _unref(billingAdminStore).loading,
        "row-class": ({ archived }) => (archived ? 'grey-row' : null),
        "data-key": "name",
        "responsive-layout": "scroll",
        "scroll-height": "440px",
        "state-key": "session-store-billing-admin-table",
        "state-storage": "session",
        class: _normalizeClass({ 'table-loading': _unref(billingAdminStore).loading })
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Billing Admins not assigned", -1)
        ]))]),
        default: _withCtx(() => [
          (billingAdminCount.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(Column), {
                  field: "name",
                  header: "Billing Admin Name",
                  "header-style": "color: #3B4242",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (data.archived)
                      ? _withDirectives((_openBlock(), _createBlock(_component_Icon, {
                          key: 0,
                          name: "info",
                          class: "mr-1 text-color-gray-dark text-base cursor-pointer"
                        }, null, 512)), [
                          [
                            _directive_tooltip,
                            {
                  value: 'Archived',
                  escape: true,
                  fitContent: true,
                },
                            void 0,
                            { top: true }
                          ]
                        ])
                      : _createCommentVNode("", true),
                    (_unref(can)([_unref(PERMISSIONS).PEOPLE_INDEX]))
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 1,
                          to: `/user/${data.id}`,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.name)
                        }, null, 8, ["to", "textContent"]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.name)
                        }, null, 8, _hoisted_2))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  "body-style": "justify-content: center; font-size: .8725rem; max-width: 10rem;",
                  "header-style": "justify-content: center; max-width: 10rem",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_ActionMenu, {
                      "menu-items": createMenuModel(data),
                      icon: "more_horiz"
                    }, null, 8, ["menu-items"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading", "row-class", "class"]),
      (billingAdminModalOpen.value && _unref(can)([_unref(PERMISSIONS).ORGANIZATION_ATTACH_BILLING_ADMINS]))
        ? (_openBlock(), _createBlock(AddPersonModal, {
            key: 0,
            title: "Add Billing Admins",
            items: billingAdminItems.value,
            searchable: true,
            "button-text": "Add Billing Admins",
            placeholder: "Search Billing Admins",
            "person-type": "Billing Admin",
            onAddItems: onSaveAdd,
            onCancel: onCancelAdd
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})